package com.essntl.features.client.ui.allclients.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.client.ui.allclients.AllClientsEvent
import com.essntl.features.client.ui.allclients.AllClientsNavigation
import com.essntl.features.client.ui.allclients.AllClientsState
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun ColumnScope.AllClientHeader(
    state: AllClientsState,
    onEvent: (AllClientsEvent) -> Unit,
    onNavigation: (AllClientsNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    var searchText by remember { mutableStateOf(state.getAllClients.query) }
    var searchJob: Job? by remember { mutableStateOf(null) }
    val scope = rememberCoroutineScope()

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Travellers",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
        )

        EsInput(
            value = searchText,
            onValueChange = {
                searchJob?.cancel()
                searchJob = scope.launch {
                    searchText = it
                    delay(500)
                    onEvent(AllClientsEvent.SearchClient(searchText))
                    onNavigation(AllClientsNavigation.CloseSidePanel)
                }
            },
            placeholder = "Search",
            prefix = {
                EsLargeIcon(
                    res = EsIcons.Search,
                )
            },
            singleLine = true,
            modifier = Modifier
                .width(300.dp),
        )

        EsLargePrimaryButton(
            onClick = {
                onNavigation(AllClientsNavigation.AddClient)
            },
            text = "Add new",
            suffixIconRes = EsIcons.Add,
        )
    }
}